var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-gap-3"},[(_vm.displayFilterItems.length > 0)?_c('div',{staticClass:"tw-text-sm tw-my-auto"},[_vm._v("Filters:")]):_vm._e(),_vm._l((_vm.displayFilterItems),function(item){return _c('base-badge',{key:item,staticClass:"tw-bg-gray-300",attrs:{"color":"gray"}},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }